var Infokiosk = {

	setup: function(force_event) {
		if (force_event != '') Events.force = force_event;
	}
};